/* stylelint-disable */
import React, {useEffect, useRef, useState} from 'react';
import SubMenu from './SubMenu';
import {useNavigate, useLocation} from 'react-router-dom';
import {CONFIG_CONSTANT} from '../../Constants/ConfigsConstants';
import openLinkIcon from '../../assets/whiteOpenLinkIcon.png';
import MenuIcon from './MenuIcon';
import {translateMenuTitle} from './menuText';
import {getAppRoutePath, getMenuHref, isIframeAppMenu} from '../appRoutes';
import {useLocale} from '../../Localization/LocaleContext';
import trackMenuClick from './trackMenuClick';

const SideMenu = ({menu, isExpand, text_color, background_color}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const {translate, locale} = useLocale();
  const isRTL = locale === 'ar';
  const windowHeight = window?.innerHeight;

  // states
  const [current_menu_position, setCurrentMenuPosition] = useState(null);
  const [isSubmenuOpen, setIsSubmenuOpen] = useState(false);
  const closeTimer = useRef(null);

  useEffect(() => () => {
    if (closeTimer.current) clearTimeout(closeTimer.current);
  }, []);

  const menu_click = (menuItem, event) => {
    // Prevent default behavior and event bubbling
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    trackMenuClick(menuItem);

    if (
      menuItem?.is_dynamic_side_menu &&
      menuItem?.is_open_via_iframe_sidepan
    ) {
      // Use href as the primary URL since it now contains the specific workflow page
      const iframeUrl = menuItem?.href || menuItem?.iframe_url || '';
      const iframeHeight = menuItem?.iframe_height || 'calc(100vh - 120px)';
      const title = menuItem?.title || 'Integration';

      const targetUrl = getAppRoutePath(menuItem);

      console.log('Main menu integration navigation:', {
        iframeUrl,
        title,
        targetUrl,
      });

      // Use React Router navigation WITHOUT page reload
      navigate(targetUrl, {
        state: {
          integration: {
            url: iframeUrl,
            title: title,
            height: iframeHeight,
          },
        },
        replace: false,
      });

      return;
    }

    // Don't navigate if menu has submenus (let submenu handle it)
    if (menuItem?.sub_menus && menuItem?.sub_menus?.length > 0) {
      setIsSubmenuOpen(previous => !previous);
      return;
    }

    if (menuItem?.is_linkable) {
      const menuHref = getMenuHref(menuItem);
      menuItem?.isOpenNewTab && menuItem?.key_name !== 'social_connect'
        ? window.open(menuHref, '_blank')
        : navigate(menuHref);
    } else {
      const menuHref = getMenuHref(menuItem);
      if (
        menuHref &&
        (!menuItem?.sub_menus || menuItem?.sub_menus?.length === 0)
      ) {
        menuItem?.isOpenNewTab && menuItem?.key_name !== 'social_connect'
          ? window.open(menuHref, '_blank')
          : navigate(menuHref);
      }
    }
  };

  const openInNewTab = event => {
    event.preventDefault();
    event.stopPropagation();
    const url = getMenuHref(menu) || menu?.iframe_url;
    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };

  // class
  const hover_button_styles =
    'bg-transparent group-hover:bg-white/10 rounded-lg transition-all duration-150 mx-1.5';
  const active_button_styles =
    'side-menu-active !bg-white/20 rounded-lg mx-1.5';

  // current path check

  const isCurrentPathActive = ({main_menu, sub_menu}) => {
    // Iframe apps share one route prefix, so match on their own app path.
    if (isIframeAppMenu(main_menu)) {
      return location.pathname === getAppRoutePath(main_menu);
    }
    let all_path = [getMenuHref(main_menu)];
    if (sub_menu && sub_menu?.length > 0) {
      all_path = [...all_path, ...sub_menu.map(getMenuHref)];
    }

    return all_path.includes(location.pathname);
  };

  //
  const onMouseEnter = event => {
    if (closeTimer.current) clearTimeout(closeTimer.current);
    const parentRect = event.currentTarget.getBoundingClientRect();
    const estimatedHeight = Math.min(520, (menu?.sub_menus?.length || 1) * 44 + 70);
    const top = Math.max(
      8,
      Math.min(parentRect.top, windowHeight - estimatedHeight - 8),
    );
    setCurrentMenuPosition({
      X: isRTL ? parentRect.left : parentRect.right,
      Y: top,
    });
    if (sub_menus_list?.length > 0) setIsSubmenuOpen(true);
  };
  //
  const onMouseOut = () => {
    if (closeTimer.current) clearTimeout(closeTimer.current);
    closeTimer.current = setTimeout(() => {
      setCurrentMenuPosition(null);
      setIsSubmenuOpen(false);
    }, 140);
  };

  //
  const allSideMenus = [
    ...(CONFIG_CONSTANT.SUPERADMIN?.sidebar_setup ?? []),
    ...(CONFIG_CONSTANT.SUPERADMIN?.dynamic_sidebar_setup ?? []),
    ...(CONFIG_CONSTANT?.DEFAULT_EXTENSION ?? []),
  ];

  const parentMenuSetup = allSideMenus.find(
    setup_menu => setup_menu?.key_name === menu?.key_name,
  );
  const sub_menus_list = menu?.sub_menus?.filter(s_menu => {
    if (s_menu?.isShow === false) return false;
    if (s_menu?.is_fixed || s_menu?.is_dynamic_side_menu) return true;
    const childSetup = allSideMenus.find(
      setup_menu => setup_menu?.key_name === s_menu?.key_name,
    );
    // Missing feature_activated means legacy configuration: keep it visible.
    if (childSetup) return childSetup.feature_activated !== false;
    if (parentMenuSetup) return parentMenuSetup.feature_activated !== false;
    return true;
  });

  return (
    <>
      <div
        className={`group  relative flex items-start justify-start  ${
          windowHeight - current_menu_position?.Y < 400
            ? 'items-end'
            : 'items-start'
        }`}
        onClick={e => menu_click(menu, e)}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseOut}>
        <div
          className={`dark-side-menu w-full relative flex min-h-[34px] items-center cursor-pointer py-1 ${
            isExpand ? 'justify-start gap-3 px-3' : 'justify-center gap-0 px-0'
          } ${isExpand ? hover_button_styles : 'bg-transparent rounded-lg transition-all duration-150 mx-0'}  ${
            isCurrentPathActive({main_menu: menu, sub_menu: menu?.sub_menus}) &&
            active_button_styles
          }`}
          style={{color: text_color}}>
          <span style={{opacity: 0.75, display: 'flex', flexShrink: 0}}>
            <MenuIcon title={menu.title} size={16} color={text_color} />
          </span>
          <p
            className={`side-menu-label ${
              isExpand
                ? 'opacity-100 block text-sm font-semibold'
                : 'opacity-0 hidden '
            } leading-5`}>
            {translateMenuTitle(menu, translate)}
          </p>
          {isExpand && menu?.isOpenNewTab && menu?.key_name !== 'social_connect' && menu?.href && (
            <button
              type="button"
              aria-label={`${translate("common.open")} ${translate(menu.title)} ${translate("common.in_a_new_tab")}`}
              className="absolute right-3 top-1/2 -translate-y-1/2 rounded p-1 opacity-0 transition-opacity group-hover:opacity-100 focus:opacity-100"
              onClick={openInNewTab}>
              <img
                className="h-4 w-4 object-contain"
                src={openLinkIcon}
                alt=""
              />
            </button>
          )}
        </div>

        {sub_menus_list?.length > 0 && (
          <div
            id={`sub_menu-${menu.title.trim()}`}
            className={`dark-side-submenu-wrapper fixed z-50 ${
              isSubmenuOpen ? 'block' : 'hidden group-hover:block'
            } ${
              // Keep a transparent hover bridge between the parent item and
              // the fixed flyout. Without it, moving the pointer to the
              // submenu briefly leaves the parent and closes the flyout.
              ''
            } `}
            style={{
              top: current_menu_position?.Y ?? 8,
              left: isRTL ? undefined : current_menu_position?.X,
              right: isRTL && current_menu_position?.X !== undefined
                ? window.innerWidth - current_menu_position.X
                : undefined,
              paddingLeft: isRTL ? 0 : 8,
              paddingRight: isRTL ? 8 : 0,
            }}
            onMouseEnter={() => {
              if (closeTimer.current) clearTimeout(closeTimer.current);
              setIsSubmenuOpen(true);
            }}
            onMouseLeave={onMouseOut}>
            <SubMenu
              background_color={background_color}
              text_color={text_color}
              main_menu={menu}
              sub_menu={sub_menus_list}
              visible_sub_menus={sub_menus_list}
              setCurrentMenuPosition={setCurrentMenuPosition}
              onClose={() => setIsSubmenuOpen(false)}
              group_id={`sub_menu-${menu.title.trim()}`}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default SideMenu;
